import { characters } from "@/mocks/manga";

export default function Characters() {
  return (
    <section id="characters" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-medium tracking-wide text-primary-600">CHARACTERS</span>
          <h2 className="font-heading mt-2 text-3xl text-foreground-950 md:text-4xl">角色关系与人物命运</h2>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            盘点《甜蜜惩罚》核心角色的人物档案与命运走向，理清他们之间纠缠的羁绊与暗涌。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {characters.map((c) => (
            <article
              key={c.name}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative h-64 w-full overflow-hidden bg-background-200">
                <img
                  src={c.img}
                  alt={`${c.name} ${c.role} 人物立绘`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-primary-700">
                  {c.arc}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-baseline justify-between gap-2">
                  <h3 className="font-heading text-xl text-foreground-950">{c.name}</h3>
                  <span className="whitespace-nowrap text-xs text-foreground-500">{c.role}</span>
                </div>
                <p className="mt-1 font-heading text-sm text-primary-600">{c.tagline}</p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {c.traits.map((t) => (
                    <span key={t} className="rounded-full bg-secondary-100 px-3 py-0.5 text-xs text-secondary-900">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}